import { useContext } from "react";
import { I18nContext } from "../contexts/I18nContext";
import { TranslationKey } from "../contexts/I18nContext/translationKeys";
export { translationKeys } from "../contexts/I18nContext/translationKeys";

export function useTranslation() {
  const context = useContext(I18nContext);

  return {
    ...context,
    getDocumentTypeTranslationKeys,
  } as const;
}

export function getDocumentTypeTranslationKeys(documentType: string) {
  return {
    name: `Texts.document.${documentType}.name` as TranslationKey,
  };
}
